import { z } from "zod";

export const AVAILABLE_FEATURES = [
    {
        id: "target-dashboard",
        label: "Target dashboard",
        description: "Displays the targets on the home dashboard",
        hidden: true
    },
    {
        id: "debug-mode",
        label: "Debug mode",
        description: "Activates the debug mode",
        hidden: false
    },
    {
        id: "disable-server-cache",
        label: "Disable server cache",
        description: "Adds headers to disable the server cache",
        hidden: false
    },
    {
        id: "apprenticeship-standard-offers",
        label: "Apprenticeship standard offers",
        description: "Open map candidates on their CRM /opportunities record instead of the legacy candidate page",
        hidden: false
    },
    {
        id: "apprenticeship-standard-map",
        label: "Apprenticeship standard map",
        description: "Hide the legacy company markers on /alternance/carte in favour of Salesforce accounts",
        hidden: false
    },
    {
        id: "apprenticeship-standard-matches",
        label: "Apprenticeship standard matches",
        description: "Read /alternance/matchs from Salesforce opportunities and account geo instead of legacy offers",
        hidden: false
    }
] as const;

export type FeatureId = (typeof AVAILABLE_FEATURES)[number]["id"];

export const FeatureSchema = z.enum(AVAILABLE_FEATURES.map(f => f.id) as [FeatureId, ...FeatureId[]]);

export type FeatureType = z.infer<typeof FeatureSchema>;

export const isFeatureEnabled = (feature: FeatureType) => {
    const enabledFeatures = localStorage.getItem(`walter-crm:feature-flags`);
    return enabledFeatures?.includes(feature);
};

export const listFeatures = () => {
    return JSON.parse(localStorage.getItem(`walter-crm:feature-flags`) || "[]") as FeatureType[];
};

export const enableFeature = (feature: FeatureType) => {
    const enabledFeatures = JSON.parse(localStorage.getItem(`walter-crm:feature-flags`) || "[]") as FeatureType[];
    enabledFeatures.push(feature);
    localStorage.setItem(`walter-crm:feature-flags`, JSON.stringify(enabledFeatures));
};

export const disableFeature = (feature: FeatureType) => {
    const enabledFeatures = JSON.parse(localStorage.getItem(`walter-crm:feature-flags`) || "[]") as FeatureType[];
    localStorage.setItem(`walter-crm:feature-flags`, JSON.stringify(enabledFeatures.filter((f: FeatureType) => f !== feature)));
};
